
import React from 'react';

function About() {
  return (
    <div>
      <h1>About Us</h1>
      <p>
        At Yearbe Ltd., we create premium white fitted sheets that blend elegance, comfort, and durability. Since 2019, we’ve focused on what matters most in bedding: a perfect fit, a soft feel, and long-lasting quality you can trust.
        Our collection includes single and double white fitted bedsheets, carefully crafted from high-quality, hypoallergenic materials. Each sheet is designed to stay snug, feel buttery-soft, and stand up to everyday use—so your bed looks crisp and feels luxurious night after night.
        Single White Fitted Sheets: Seamless balance of practicality and comfort for daily use—soft, breathable, and durable.
        Double White Fitted Sheets: Perfect-fit elastic, irritation-free materials ideal for sensitive skin, and built for longevity.
        With a clean, timeless aesthetic, our sheets elevate any bedroom while delivering the comfort and reliability you expect. At Yearbe, we’re committed to making your home feel more luxurious and comfortable with every sleep.

        Why Yearbe

        Premium, hypoallergenic materials

        Snug, stay-put fit and easy care

        Softness + strength for everyday use

        UK brand, founded 2019
      </p>
      
    </div>
  );
}

export default About;
